module.exports = __webpack_public_path__ + "img/calendar-project.e9eb4c84.svg";